<template>
	<div id="indexpage"  v-title :data-title="title" :indexnum="0" style="background-color: #041034; height: 100%;">  
			 
		<leftnav mkcode="D" itemcode="D-ZHFZ"  :smScrennFull="true"></leftnav>
	 
		<!-- 弹框 -->	
		
		<!-- <Resize> -->
		<div class="por"> 
		<!-- 全屏开始 -->
		<i class="el-icon-full-screen swiper_fullscreen" @click="screen()"></i>
		<!-- 全屏结束 -->
			<div class="index-swiper">
				<!-- <h2 class="title lineartitle">{{userdata.cityText}}{{title}}</h2> -->
				<div class="indexflex hgsjswiper">
					<div class="col3 colbox  hgsjswiper_left ">
						<div class="transparentbg hgsj_seasongdp hgsj_charth">
							<h4 class="blocktitle">公共财政收入（亿元）</h4>
							<div id="hgsj_seasongdp" class="echartbox"></div>
						</div>
						<div class="transparentbg hgsj_areagdp hgsj_charth" >
							<h4 class="blocktitle">社会人均收入、支出(元)</h4>
							<div id="hgsj_areagdp" class="echartbox"></div>
						</div>
						<div class="transparentbg hgsj_threepercent hgsj_charth" >
							<h4 class="blocktitle">三大产业生产总值比重（亿元）</h4>
							<div id="hgsj_threepercent" class="echartbox"></div>
						</div>
						
					</div>
					<div class="col4 colbox hgsjswiper_cen">
						 <!-- <h2 class="title pagetitle" @mouseover='drawer = true'>
								<span>{{userdata.cityText}}</span>{{title}}<i class="el-icon-arrow-down dataswipertitle_icon"></i>
								</h2> -->
							<daswiperNav :title="title" navcode="HGSJ"  :indexnum="1" :fulltitle="false"></daswiperNav>
							<div class="oh hgsj_map_saas">
								<div id="hgsj_map_saas"></div> 
							</div>
							<div class="transparentbg hgsj_gdpchange hgsj_charth">
								<h4 class="blocktitle">GDP变化</h4>
								<div id="hgsj_gdpchange"></div>
							</div>
					</div>
					<div class="col3 colbox hgsjswiper_rig">
						<div class="transparentbg threetotal hgsj_charth" >
							<h4 class="blocktitle">用电量变化（亿千瓦小时）</h4>
							<div id="threetotal" class="echartbox"></div>
						</div>
						<!-- <div class="transparentbg hgsj_fixassets">
							<h4 class="blocktitle">2020年固定资产投资</h4>
							<div id="hgsj_fixassets" class="echartbox"></div>
						</div> -->
						<div class="transparentbg hgsj_imexport hgsj_charth">
							<h4 class="blocktitle">进出口总额变化（万美元）</h4>
							<div id="hgsj_imexport" class="echartbox"></div>
						</div>
						<div class="transparentbg hgsj_quota hgsj_charth">
							<h4 class="blocktitle">社会消费品零售总额</h4> 
							<div id="hgsj_retail"></div>
						</div>
					</div> 
				</div>
			</div>
		</div>
		<!-- </Resize> -->
	</div>
</template> 
<script>
	import countTo from 'vue-count-to'; 
	export default {
		name: 'hongguanshuju',
		data() {
			return { 
				isCollapse:false,
				isFullscreen: false,
				direction:"ltr",  //btt
				direction2:"btt",  //btt
				 drawer: false,
					drawer2: false,
					modal:false,				
				title:"宏观数据监测大屏", bgcolor:"#041034",
				userdata:{}, 
				pagedata:{table:{ylws:{}}},
				public_tooltip: {
					trigger: 'axis',
					backgroundColor: 'rgba(255,255,255,0.9)',
					borderColor: '#ddd',
					borderWidth: '1',
					textStyle: {
						color: '#000',
						fontSize: 14,
					}
				},
				contodefault:{
								duration:3000,autoplay:true
							}, 
							 startVal: 0,		//数字滚动开始值
								endVal: 1425.44,  //数字滚动结束值
				mapurl: 'map/city/321200.json',
				colors: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#ff0", "#f87f8f"],
				//假数据
		 holdechartBardata1:[],
			tableshowbtn:2,
			tablisttitle:['医疗卫生保障','财政收支','能源消耗','金融保险','人口'],
			tabledata1:[ {name:'',val2016:0,val2017:0,val2018:0,val2019:0,val2020:0},   ],
			tabledata2:[ {name:'',val2016:0,val2017:0,val2018:0,val2019:0,val2020:0},   ],
			tabledata3:[ 
						{name:'能源消费总量（万吨）',val2016:1000,val2017:1000,val2018:1000,val2019:1000,val2020:1000},  
						{name:'煤炭消费量（万吨）',val2016:1000,val2017:1000,val2018:1000,val2019:1000,val2020:1000}, 
						{name:'原油消费量（万吨）',val2016:1000,val2017:1000,val2018:1000,val2019:1000,val2020:1000}, 
						{name:'天然气消费量（万吨）',val2016:1000,val2017:1000,val2018:1000,val2019:1000,val2020:1000},  
						{name:'电力消费量（万吨）',val2016:1000,val2017:1000,val2018:1000,val2019:1000,val2020:1000},  
						{name:'水消费量（万吨）',val2016:1000,val2017:1000,val2018:1000,val2019:1000,val2020:1000},   
						],
				tabledata4:[ {name:'',val2016:0,val2017:0,val2018:0,val2019:0,val2020:0},   ],
				tabledata5:[ {name:'',val2016:0,val2017:0,val2018:0,val2019:0,val2020:0},   ],
				threepercentdata:[{name:"第一产业",value:5563},{name:"第二产业",value:4826},{name:"第三产业",value:4440}],
				fixassetsdata:[{name:"固定资产",value:5563},{name:"第一产业",value:4826},{name:"第二产业",value:4440},{name:"第三产业",value:4440}],
				zuobiaodata:[
											{name: "高港区", 	value: [119.937957,32.325631,1432],}, 
											{name: "泰兴市", value: [120.058028,32.178851,1253]}, 
											{name: "海陵区",value: [119.930047,32.498345,1104]},
											{name: "靖江市",value: [120.273548,32.109246,991]	},
											{name: "兴化市",value: [119.958762,32.918031,593]},
											{name: "姜堰市",	value: [120.133607,32.516314,460]},
									],
				ydata:[
												{name: "高港区", 	value: 1432}, 
												{name: "泰兴市", value: 1253}, 
												{	name: "海陵区",value: 1104},
												{name: "靖江市",value: 991},
												{name: "兴化市",value: 593},
												{name: "姜堰市",	value: 460},
										], 
				retail:[
												{name: "2016年", 	value: 1432}, 
												{name: "2017年", value: 1253}, 
												{	name: "2018年",value: 1104},
												{name: "2019年",value: 991},
												{name: "2020年",value: 593}, 
										], 
			}
		},
		props: {
			msg: String,
		},
		computed: {
		defaultOption () {
			return {
				step: 0.1, // 数值越大速度滚动越快
				limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
				hoverStop: true, // 是否开启鼠标悬停stop
				direction: 1, // 0向下 1向上 2向左 3向右
				openWatch: true, // 开启数据实时监控刷新dom
				singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
				singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
				waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
			}
			} 
		},　　 
		
		mounted() {
			document.getElementById('app').style.background=this.bgcolor; 
			this.userdata=this.getuseriformation(); 
		 this.mapurl =  'map/'+this.userdata.currentCity.type+'/'+this.userdata.currentCity.mapname+'.json';
			// console.log(this.userdata);
			this.bus.$emit('loading', true);
			if(this.userdata.edition<1){
				var _this=this;
				alert('升级版本后即可查看本页面,自动跳转');
				setTimeout(function(){
					_this.routerself('/totalEnterprises');
				},1000)
				return;
			}
			this.getajaxdata();
			var _this=this; 
		},
		methods: {  
			getajaxdata(){
				var _this=this;
				this.bus.$emit('loading', true);
				// console.log(this.title);
				this.$axios.get(this.$api.cyl.govsaaschart.macrodata(),{headers:{AuthToken:this.userdata.token}}).then(function(res){
					// console.log('宏观数据监测',res); 
					if(res.data.success){
						_this.bus.$emit('loading', false);
						_this.pagedata = res.data.data;
						var seasongdpdata = res.data.data.cz0101; 
						var fixassetsdata = res.data.data.dc0204; 
						var importdata =res.data.data.import;
						var threepercendata = res.data.data.gdp123; 
						var gdpchangedata = res.data.data.gdpGrowthRate;   
						_this.seasongdpFun('hgsj_seasongdp',seasongdpdata); //公共财政收入
						// _this.fixassetsFun('hgsj_fixassets',fixassetsdata); //2020年固定资产投资
						_this.imexportFun('hgsj_imexport',importdata); //进出口总额
						_this.threepercentFun('hgsj_threepercent',threepercendata); //三大产业生产总值 
						_this.gdpchangeFun('hgsj_gdpchange',gdpchangedata);   //2016-2020年GDP变化
						_this.mapGeo('hgsj_map_saas',res.data.data.gdp2020,_this.zuobiaodata); //地图
						_this.retailchartFun('hgsj_retail',res.data.data.xf0101); // 社会消费品零售总额
						_this.TaxchartFun('hgsj_areagdp',res.data.data.sh0101,res.data.data.sh0201); //社会收入支出 
					_this.threetotalFun('threetotal',res.data.data.gdplist.gdp1,res.data.data.gdplist.gdp2,res.data.data.gdplist.gdp3); //用电量变化
						//--------- 
						_this.bus.$emit('loading', false);
					} 
					if(res.data.code==100101||res.data.code==100100||res.data.code==100102){
						// console.log('token验证失败');
						_this.logout();
					}
				}).catch(function (error) { 
					_this.bus.$emit('loading', false);
					// 请求失败处理 console.log(error);
				});  
			},  
			
			chagedata(data){ 
				for(var i = 0;i<data.length;i++){
					if(data[i].unit=="万元"){ 
						data[i].value =(data[i].value)*0.0001; 
					}
					if(data[i].unit=="万美元"){
						data[i].value =(data[i].value)*0.00063;
					}
				} 
			}, 
			 //社会消费品零售总额
			 retailchartFun(el,data){
			 	var charPie3currentIndex = 0,isSet = true;//为了做判断：当鼠标移动上去的时候，自动高亮就被取消
			 	var  Taxchart= echarts.init(document.getElementById(el)); 
					var xdata=[],ydata=[];
					for(var i=0;i<data.length;i++){
						xdata.push(data[i].name);
						ydata.push(data[i].value); 
					}
			 	var 	option = {
			 	  tooltip: {
			 				show:true,
			 	    trigger: 'axis', 
			 				formatter:"<span style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#1890ff'></span>总额：{c} 亿元"
			 	  },
			 	  legend: {top: '5%',right:'5%',textStyle:{color:"#eee",fontSize:12,lineHeight:100},orient:'vertical',itemWidth:8,itemHeight:8, },	//图例圆形icon:'circle'
			 			grid:{  x:'10%', y:'15%', x2:'10%',y2:'15%' },
			 	  xAxis: [
			 	    {
			 	      type: 'category',
			 	      data: xdata,
			 	      axisPointer: {
			 	        type: 'shadow'
			 	      },
			 							axisLine: {
			 								show:true,
			 							lineStyle:{
			 								color:'#eee',
			 							}
			 							},
			 						axisLabel:{
			 									formatter:function (value, index) {return value+'年'; },  // x轴加单位
			 						},
			 	    }
			 	  ],
			 	  yAxis: [
			 	    { 
			 	      type: 'value',
			 	      name: '',
			 	      // min: 0,
			 	      // max: 60,  
			 	      axisTick:{"show":true },		//刻度线
			 							axisLine: {														//轴线
			 								show:true,
			 							lineStyle:{
			 								color:'#eee',
			 							}
			 							},  
			 							splitLine:{show:false}, //不显示网格线
			 	    }, 
			 	  ],
			 	  series: [ 
			 	    {
			 	      name: '总额（亿元）',
			 	      type: 'pictorialBar',
			 							barWidth:30,
			 							color:'#1890ff' ,
			 							// barCategoryGap: '40%',
			 							symbol: 'roundRect',  //roundRect
			 							symbolOffset: [0, 0],//柱子的位置
			 							symbolSize: [30, 8],//size,单个symbol的大小
			 							symbolRepeat: true,//是否重复symbol
			 							symbolMargin: '4', //图形垂直间隔
			 								// barGap: 50,//柱子的“粗细” 
			 							label:{
			 							  normal:{ 
			 							  show: false, 
			 							  position: 'top',  //显示顶部数据
			 									color : '#fff',  
			 							   }
			 							},
			 								itemStyle: { 
			 								        // 移入当前的柱状图时改变颜色
			 								        emphasis: {
			 								            color: '#08e5ff',
			 								        }
			 								    },   
			 	      data: ydata
			 	    }, 
			 	  ]
			 	};
			 	Taxchart.setOption(option); 
			 	var startCharts = null;
			 	// 2、鼠标移动上去的时候的高亮动画
			 	Taxchart.on('mouseover', function(param) {
			 		isSet = false
			 		clearInterval(startCharts)
			 		// 取消之前高亮的图形
			 		Taxchart.dispatchAction({
			 			type: 'downplay',
			 			seriesIndex: 0,
			 			dataIndex: charPie3currentIndex, 
			 		})
			 		// 高亮当前图形
			 		Taxchart.dispatchAction({
			 			type: 'highlight',
			 			seriesIndex: 0,
			 			dataIndex: param.dataIndex
			 		})
			 		// 显示 tooltip
			 		Taxchart.dispatchAction({
			 			type: 'showTip',
			 			seriesIndex: 0,
			 			dataIndex: param.dataIndex
			 		})
			 	});
			 	var chartHover = function() {
			 		var dataLen = option.series[0].data.length
			 		// 取消之前高亮的图形
			 		Taxchart.dispatchAction({
			 			type: 'downplay',
			 			seriesIndex: 0,
			 			dataIndex: charPie3currentIndex
			 		})
			 		charPie3currentIndex = (charPie3currentIndex + 1) % dataLen
			 		// 高亮当前图形
			 		Taxchart.dispatchAction({
			 			type: 'highlight',
			 			seriesIndex: 0,
			 			dataIndex: charPie3currentIndex
			 		})
			 		// 显示 tooltip
			 		Taxchart.dispatchAction({
			 			type: 'showTip',
			 			seriesIndex: 0,
			 			dataIndex: charPie3currentIndex
			 		})
			 	}
			 	startCharts = setInterval(chartHover, 2000)
			 	// 4、鼠标移出之后，恢复自动高亮
			 	Taxchart.on('mouseout', function(param) {
			 		if (!isSet) {
			 			startCharts = setInterval(chartHover, 2000)
			 			isSet = true
			 		}
			 	});
			 },
			
			//公共财政收入
			seasongdpFun(el,data){
				// console.log('财政收入',el,data);
				var  seasongdp= echarts.init(document.getElementById(el)); 
				var _this = this,xdata=[],ydata=[];
				for(var i=0;i<data.length;i++){
					xdata.push(data[i].name);
					ydata.push(data[i].value); 
				}
				var 	option = {
				  tooltip: {
				    trigger: 'axis',  
								formatter: function (params) {
									var result="";
									console.log(params)
									params.forEach((list,i)=>{
										var br=i==list.length-1?'':'</br>';
										result += list.marker+list.name + '年 公共财政收入: ' + list.data +'亿 '+br ; 
									});
									return result;
								}
				  }, 
				  legend: {show:false },
						grid:{  x:20, y:20, x2:40,y2:40 },
				  xAxis: [
				    {
				      type: 'category',
				      data:xdata,
				      axisPointer: {
				        type: 'shadow'
				      },
										axisLine: {
											show:false,
										lineStyle:{
											color:'#eee',
										}, 
										},
										axisTick:{"show":false },
										axisLabel:{
													formatter:function (value, index) {return value+'年'; },  // x轴加单位
										},
				    }
				  ],
				  yAxis: [
				    {
				      type: 'value',
				      name: ' ',  
				      axisTick:{"show":false },
										axisLine: {
											show:false,
										lineStyle:{
											color:'#eee',
										}
										},   
										splitLine:{show:false}, //不显示分割线
										axisLabel : {
										            formatter: function(){   //不显示y轴数据
										                return "";
										            }
										        }
				    },  
				  ],
				  series: [ 
				    {
									
				      name: '公共财政收入（亿元）',
				      type: 'bar',
										barWidth:32,
										// showBackground: true,
										itemStyle: {
											borderRadius:[30,30,0,0],
												color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
													{ offset: 0, color: '#83bff6' },
													{ offset: 0.7, color: '#2378f7' },
													{ offset: 1, color: '#2378f7' }
												
												])
										},
										emphasis: {
												itemStyle: {
														color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
															{ offset: 1, color: '#f00' },
															{ offset: 0.5, color: '#f20' },
															{ offset: 0, color: '#f60' }
														])
												}
										},
										color:'#1890ff',
										label:{ 							//图表顶部显示数据
										  normal:{ 
										  show: true, 
										  position: 'top',			//显示位置顶部
												color : '#fff',				//文字颜色
												formatter: '{@score}'+'亿元'
										   }
										},
				      data:ydata,
				    }, 
				  ]
				};
				seasongdp.setOption(option);  
			},
			
		//社会人均收入、支出
		TaxchartFun(el,srdata,zcdata) {
			var charPie3currentIndex = 0,isSet = true; //为了做判断：当鼠标移动上去的时候，自动高亮就被取消
			var Taxchart = echarts.init(document.getElementById(el)); 
			var xdata=[],sr=[],zc=[];
			// console.log('社会人均收入支出',el,srdata,zcdata);
			for(var i=0;i<srdata.length;i++){
				xdata.push(srdata[i].name);
				sr.push(srdata[i].value); 
			}
			for(var j=0;j<zcdata.length;j++){
				zc.push(zcdata[j].value);
			} 
			var		option = {
			  title: {
			    text: '',
			  },
			  tooltip: {
			    show:true,
							trigger: 'axis'
			  },
			  legend: {
			    show:true,
							textStyle:{color:"#eee",fontSize:12,},
							icon:'rect',  //图例样式 圆点circle 矩形rect
							itemWidth:10,
							itemHeight:9, 
							right:'5%',
			  }, 
			  grid: {
			    left: '3%',
			    right: '4%',
			    bottom: '3%',
			    containLabel: true
			  },
			  xAxis: [
			    {
			      type: 'category',
			      boundaryGap: false,
									color:"#eee",
			      data:xdata,
									axisLine: {show:true,  lineStyle:{ color:'#eee', } }, 		//轴线
									axisTick:{show:false }, //刻度线
									axisLabel:{
												formatter:function (value, index) {return value+'年'; },  // x轴加单位
									},
			    }
			  ],
			  yAxis: [
			    {
			      type: 'value', 
									min:0,				//最小值
									// max: 400,			//最大值
									// interval: 100,		//步长值
									splitLine:{show:false}, //不显示网格线
									axisLine: {show:false,  lineStyle:{ color:'#eee', } }, 		//轴线
			    }
			  ],
			  series: [
			    {
													name: '收入',
			          data: sr,
			          type: 'line',
			          smooth: true, //线条平滑 
													symbol:'circle', //拐点样式
													symbolSize: 5,//拐点大小
													color:'#1890ff',
													areaStyle: {color:'rgba(0,176,255,.5)'},
													// stack: 'Total', //同个类目轴上系列配置相同的stack值后，后一个系列的值会在前一个系列的值上相加
			        },
			        {
												name: '支出',
			          data: zc,
			          type: 'line',
			          smooth: true, //线条平滑
													symbol:'circle', //拐点样式
													symbolSize: 5,//拐点大小
													areaStyle: {color:'rgba(254,100,29,.5)'},
													color:'#ffbb1c',
													// stack: 'Total', //同个类目轴上系列配置相同的stack值后，后一个系列的值会在前一个系列的值上相加
			        }	
			  ]
			};
			Taxchart.setOption(option);
		
		},
		
			//2020年三大产业生产总值比重
 threepercentFun(el,data){ 
 		var charPie3currentIndex = 0,isSet = true;//为了做判断：当鼠标移动上去的时候，自动高亮就被取消
 		var threepercent = echarts.init(document.getElementById(el)); 
			var _this = this;
			for(var i=0;i<data.length;i++){ 
			 var name1 = data[i].jj0103_text.substr(0,4);
				var name2 = data[i].jj0104_text.substr(0,4);
				var name3 = data[i].jj0105_text.substr(0,4);
				var value1 =data[i].jj0103;
				var value2 = data[i].jj0104;
				var value3 = data[i].jj0105;
			}  
 		var 	option = {
 		  tooltip: {
 					show:true,
 		    trigger: 'item',
 		  },
 		  legend: {top: 'center',right:'15%',textStyle:{color:"#eee",fontSize:12,lineHeight:100},orient:'vertical',itemWidth:6,itemHeight:6, icon:'circle'	//图例圆形 
 				}, 
 		  series: [
 					{ 
									type: 'pie',radius: ['45%', '60%'],center: ["35%", "53%"], label: {show: true,color:'#fff',fontSize:12,formatter: '{d}%',},
 		      emphasis: {show:true,label: {show: true,}}, 
									data: [{name:name1,value:value1},{name:name2,value:value2},{name:name3,value:value3}],
									}
 		  ]
 		};
 		threepercent.setOption(option); 
			var startCharts = null;
			// 2、鼠标移动上去的时候的高亮动画
			threepercent.on('mouseover', function(param) {
				isSet = false
				clearInterval(startCharts)
				// 取消之前高亮的图形
				threepercent.dispatchAction({
					type: 'downplay',
					seriesIndex: 0,
					dataIndex: charPie3currentIndex
				})
				// 高亮当前图形
				threepercent.dispatchAction({
					type: 'highlight',
					seriesIndex: 0,
					dataIndex: param.dataIndex
				})
				// 显示 tooltip
				threepercent.dispatchAction({
					type: 'showTip',
					seriesIndex: 0,
					dataIndex: param.dataIndex
				})
			});
			var chartHover = function() {
				var dataLen = option.series[0].data.length
				// 取消之前高亮的图形
				threepercent.dispatchAction({
					type: 'downplay',
					seriesIndex: 0,
					dataIndex: charPie3currentIndex
				})
				charPie3currentIndex = (charPie3currentIndex + 1) % dataLen
				// 高亮当前图形
				threepercent.dispatchAction({
					type: 'highlight',
					seriesIndex: 0,
					dataIndex: charPie3currentIndex
				})
				// 显示 tooltip
				threepercent.dispatchAction({
					type: 'showTip',
					seriesIndex: 0,
					dataIndex: charPie3currentIndex
				})
			}
			startCharts = setInterval(chartHover, 2000)
			// 4、鼠标移出之后，恢复自动高亮
			threepercent.on('mouseout', function(param) {
				if (!isSet) {
					startCharts = setInterval(chartHover, 2000)
					isSet = true
				}
			});
 	}, 
		
		//用电量变化
		threetotalFun(el,shdata,gydata,jmdata){
			var  threetotal= echarts.init(document.getElementById(el));
			// console.log('用电',el,shdata,gydata,jmdata);
			var xdata =[],sh=[],gy=[],jm=[];
			for(var i=0;i<shdata.length;i++){
				xdata.push(shdata[i].name);
				sh.push(shdata[i].value); 
			}
			for(var j=0;j<gydata.length;j++){
				gy.push(gydata[j].value);
			}
			for(var n=0;n<jmdata.length;n++){
				jm.push(jmdata[n].value);
			} 
			var option = {
			  title: {
			    text: ' ', 
			  },
			  tooltip: {
			    trigger: 'axis',
							formatter: function (params) { 
									var result="";
									params.forEach((list,i)=>{
										var br=i==list.length-1?'':'</br>';
										result += list.marker+list.name + '年 '+list.seriesName+': ' + list.data +'亿 '+br ; 
									});
									return result;
							}
			  }, 
					legend: {
								show:true,
								data:  ['社会用电', '工业用电', '居民用电'],
							 textStyle:{color:"#eee",fontSize:12,itemWidth:10,itemHeight:10,},
								icon:'rect',  //图例样式 圆点circle 矩形rect
								itemWidth:16,
								itemHeight:2,
								right:'3%',
					},
			  grid: {
			    left: '3%',
			    right: '4%',
			    bottom: '3%', 
			    containLabel: true
			  }, 	
			  xAxis: {
			    type: 'category',
			    boundaryGap: false,
			    data: xdata,
							axisLabel:{fontSize: 13,color:'#eee',formatter:function (value, index) {return value+'年'; }, }, // x轴加单位
							axisLine: {
								show:true,
							lineStyle:{
								color:'#eee',
							}, 
							},
			  },
			  yAxis: {
			    type: 'value',
							splitLine: {           //分割线
							 show: false,     //控制分割线是否显示
							},
							axisLine: {show:true}  ,//显示坐标轴
							axisTick:{
								"show":true   ,//去掉x轴刻度线
							 },
								axisLabel:{fontSize: 13,color:'#eee'},
								axisLine: {
									show:true,
								lineStyle:{
									color:'#eee',
								}
								},
			  },
			  series: [
			    {
			      name: '社会用电',
			      type: 'line',
			      stack: 'Total',
			      data: sh
			    },
			    {
			      name: '工业用电',
			      type: 'line',
			      stack: 'Total',
			      data: gy
			    },
			    {
			      name: '居民用电',
			      type: 'line',
			      stack: 'Total',
			      data: jm
			    }, 
			  ]
			}; 
			threetotal.setOption(option);
		},
		/*
	todo
		formatter: function (params) {
			return  result = params[0].marker+params[0].name + '年 进出口总额变化 ' + params[0].data +'万（美元）' ; 
		}
		*/
		//2016-2020年GDP变化
		gdpchangeFun(el,data){
			var charPie3currentIndex = 0,isSet = true;//为了做判断：当鼠标移动上去的时候，自动高亮就被取消
			var  gdpchange= echarts.init(document.getElementById(el)); 
			var _this = this,xdata=[],ydata=[],ydata2=[];
			for(var i=0;i<data.length;i++){
				xdata.push(data[i].year);
				ydata.push(data[i].value); 
				ydata2.push(data[i].percent);
			}
			// console.log(xdata,ydata,ydata2);
			var 	option = {
			  tooltip: {
			    trigger: 'axis', 
						formatter: function (params) { 
						        var result = ''
						        var dotHtml = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#1890ff"></span>'    // 定义第一个数据前的圆点颜色
						        result += dotHtml + ' GDP（亿元） ' + params[0].data + "亿元</br>" + dotHtml + ' GDP增速（%） ' + params[1].data+'%';
						        return result
						    }
			  }, 
			  legend: {show:true,textStyle:{color:'#fff'} },
					grid:{  x:40, y:30, x2:40,y2:40 },
			  xAxis: [
			    {
			      type: 'category',
			      data: xdata,
			      axisPointer: {
			        type: 'shadow'
			      },
									axisLine: {
										show:true,
									lineStyle:{
										color:'#eee',
									}
									},
									axisLabel:{
												formatter:function (value, index) {return value+'年'; },  // x轴加单位
									},
			    }
			  ],
			  yAxis: [
			    { 
			      type: 'value',
			      name: '亿元',
			      // min: 0,
			      // max: 60,  
			      axisTick:{"show":true },		//刻度线
									axisLine: {														//轴线
										show:true,
									lineStyle:{
										color:'#eee',
									}
									},  //显示y轴刻度线
									splitLine:{show:false}, //不显示网格线
			    },
			    {
									name: '%',
			      type: 'value', 
			      min: 0,
			      max: 10,
			      interval: 2,
									axisTick:{"show":true }, //刻度线
									splitLine:{ show:false}, //不显示网格
									axisLine: {															//轴线
										show:false,
									lineStyle:{
										color:'#eee',
									}
									},  //显示y轴刻度线
			    }
			  ],
			  series: [ 
			    {
								showBackground: true, 
			      name: 'GDP',
			      type: 'bar',
									barWidth:32,
									color:'#1890ff',
									label:{
									  normal:{ 
									  show: true, 
									  position: 'top',
											color : '#fff',
											formatter: '{@score}'+'亿元'
									   }
									},
			      data: ydata
			    },
			    {
								 markPoint: {
											data: [
													{ type: 'max', name: 'Max' },
													{ type: 'min', name: 'Min' }
											]
									},
									markLine: {
											data: [{ type: 'average', name: 'Avg' }]
									},
			      name: 'GDP增速',
			      type: 'line',
									smooth: true, //线条平滑
			      yAxisIndex: 1,
									color:'#ff0',
									itemStyle:{
										
										normal:{
											lineStyle:{
												type:"dotted", 
												width:4,
											}
										}
									},
			      data: ydata2,
			    }
			  ]
			};
			gdpchange.setOption(option); 
		},
		
		//2020年固定资产投资
		fixassetsFun(el,data){ 
			var charPie3currentIndex = 0,isSet = true;//为了做判断：当鼠标移动上去的时候，自动高亮就被取消 
			var chart = echarts.init(document.getElementById(el)); 
			var _this = this,xline=[],seriesline=[];  
			for(var i=0;i<data.length;i++){ 
				xline.push(data[i].name); 
				seriesline.push(data[i].value);
			};
			// console.log('data',data,xline,seriesline);
			var option = {
				title:{
					text:"",left:25,top:20, textStyle:{color:'#eee',fontSize:16}
				},
				tooltip:{
					trigger: 'axis',
					backgroundColor: 'rgba(255,255,255,0.9)',
					borderColor: '#ddd',
					borderWidth: '1',
					textStyle: {
						color: '#000',
						fontSize: 14,
					},
					formatter: '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#1890ff"></span>'+'{b}：'+'{c}'+'亿元',
					},
				color: _this.colors,
				grid: { x: 78, 	y: 10, x2: 50, y2: 20, show: true, 	borderWidth: 0,},
				label: { show: true, position: 'right', valueAnimation: true ,color:'#fff',formatter: '{@score}'+'亿元'},
				xAxis: {	type: 'value',axisTick:{show:false},boundaryGap: [0, 0.01],splitLine:{show:false},axisLabel : {formatter: function(){ return "";},}},
				yAxis: { type: 'category',splitLine:{show:false},axisTick:{show:false},axisLine: {show:true},data: xline,axisLabel:{fontSize: 13,color:'#eee',formatter:function (value, index) {return value+'年'; },}},// y轴加单位 
				series: [{ data: seriesline, type: 'bar', barWidth:20,}]
			};
			chart.setOption(option);  
			var startCharts = null;
			// 2、鼠标移动上去的时候的高亮动画
			chart.on('mouseover', function(param) {
				isSet = false
				clearInterval(startCharts)
				// 取消之前高亮的图形
				chart.dispatchAction({
					type: 'downplay',
					seriesIndex: 0,
					dataIndex: charPie3currentIndex
				})
				// 高亮当前图形
				chart.dispatchAction({
					type: 'highlight',
					seriesIndex: 0,
					dataIndex: param.dataIndex
				})
				// 显示 tooltip
				chart.dispatchAction({
					type: 'showTip',
					seriesIndex: 0,
					dataIndex: param.dataIndex
				})
			});
			var chartHover = function() {
				var dataLen = option.series[0].data.length
				// 取消之前高亮的图形
				chart.dispatchAction({
					type: 'downplay',
					seriesIndex: 0,
					dataIndex: charPie3currentIndex
				})
				charPie3currentIndex = (charPie3currentIndex + 1) % dataLen
				// 高亮当前图形
				chart.dispatchAction({
					type: 'highlight',
					seriesIndex: 0,
					dataIndex: charPie3currentIndex
				})
				// 显示 tooltip
				chart.dispatchAction({
					type: 'showTip',
					seriesIndex: 0,
					dataIndex: charPie3currentIndex
				})
			}
			startCharts = setInterval(chartHover, 2000)
			// 4、鼠标移出之后，恢复自动高亮
			chart.on('mouseout', function(param) {
				if (!isSet) {
					startCharts = setInterval(chartHover, 2000)
					isSet = true
				}
			});
		},	
		
		
		//2016-2020年进出口总额变化（万美元）
		imexportFun(el,data){ 
			var charPie3currentIndex = 0,isSet = true;//为了做判断：当鼠标移动上去的时候，自动高亮就被取消
			var  imexport= echarts.init(document.getElementById(el)); 
			var _this = this,xdata=[],ydata=[],ydata2=[];
			for(var i=0;i<data.length;i++){
				xdata.push(data[i].name);
				ydata.push(data[i].value);
			}
			var 	option = {
			  tooltip: {
			    trigger: 'axis', 
						formatter: function (params) {
							return  params[0].marker+params[0].name + '年进出口总额：' + params[0].data +'万（美元）' ; 
						}
			  }, 
			  legend: {show:false },
					grid:{  x:40, y:30, x2:40,y2:40 },
			  xAxis: [
			    {
			      type: 'category',
			      data: xdata,
			      axisPointer: {
			        type: 'shadow'
			      },
									axisLine: {
										show:true,
									lineStyle:{
										color:'#eee',
									}
									},
									axisLabel:{
												formatter:function (value, index) {return value+'年'; },  // x轴加单位
									},
			    }
			  ],
			  yAxis: [
			    { 
			      type: 'value',
			      name: '万美元',
			      // min: 0,
			      // max: 60,  
			      axisTick:{"show":true },		//刻度线
									axisLine: {														//轴线
										show:true,
									lineStyle:{
										color:'#eee',
									}
									},  //显示y轴刻度线
									splitLine:{show:false}, //不显示网格线
			    },
			    // {
							// 		name: '%',
			    //   type: 'value', 
			    //   min: 0,
			    //   max: 10,
			    //   interval: 2,
							// 		axisTick:{"show":true }, //刻度线
							// 		splitLine:{ show:false}, //不显示网格
							// 		axisLine: {															//轴线
							// 			show:false,
							// 		lineStyle:{
							// 			color:'#eee',
							// 		}
							// 		},  //显示y轴刻度线
			    // }
			  ],
			  series: [ 
			    {
			      name: '进出口总额',
			      type: 'bar',
									barWidth:32,
									showBackground: true,
									itemStyle: {
										borderRadius:[30,30,0,0],
											color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
													{ offset: 0, color: '#83bff6' },
													{ offset: 0.7, color: '#2378f7' },
													{ offset: 1, color: '#2378f7' },
											])
									},
									emphasis: {
											itemStyle: {
													color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [ 
															{ offset: 1, color: '#f00' },
															{ offset: 0.5, color: '#f20' },
															{ offset: 0, color: '#f60' }
													])
											}
									},
									
									color:'#1890ff',
									label:{
									  normal:{ 
									  show: true, 
									  position: 'top',
											color : '#fff',
											formatter: '{@score}'//
									   }
									},
			      data: ydata
			    },
			    // {
			    //   name: 'GDP增速',
			    //   type: 'line',
			    //   yAxisIndex: 1,
							// 		color:'#1890ff',
							// 		itemStyle:{
							// 			normal:{
							// 				lineStyle:{
							// 					type:"dotted"
							// 				}
							// 			}
							// 		},
			    //   data: [3.6, 4.8, 4.8, 8.2, 9.5]
			    // }
			  ]
			};
			imexport.setOption(option); 
			var startCharts = null;
			// 2、鼠标移动上去的时候的高亮动画
			imexport.on('mouseover', function(param) {
				isSet = false
				clearInterval(startCharts)
				// 取消之前高亮的图形
				imexport.dispatchAction({
					type: 'downplay',
					seriesIndex: 0,
					dataIndex: charPie3currentIndex
				})
				// 高亮当前图形
				imexport.dispatchAction({
					type: 'highlight',
					seriesIndex: 0,
					dataIndex: param.dataIndex
				})
				// 显示 tooltip
				imexport.dispatchAction({
					type: 'showTip',
					seriesIndex: 0,
					dataIndex: param.dataIndex
				})
			});
			var chartHover = function() {
				var dataLen = option.series[0].data.length
				// 取消之前高亮的图形
				imexport.dispatchAction({
					type: 'downplay',
					seriesIndex: 0,
					dataIndex: charPie3currentIndex
				})
				charPie3currentIndex = (charPie3currentIndex + 1) % dataLen
				// 高亮当前图形
				imexport.dispatchAction({
					type: 'highlight',
					seriesIndex: 0,
					dataIndex: charPie3currentIndex
				})
				// 显示 tooltip
				imexport.dispatchAction({
					type: 'showTip',
					seriesIndex: 0,
					dataIndex: charPie3currentIndex
				})
			}
			startCharts = setInterval(chartHover, 2000)
			// 4、鼠标移出之后，恢复自动高亮
			imexport.on('mouseout', function(param) {
				if (!isSet) {
					startCharts = setInterval(chartHover, 2000)
					isSet = true
				}
			});
		},
		
		//地图
		mapGeo(el, data,scdata) {
						var myChart = echarts.init(document.getElementById(el));
						var mapUrl = this.mapurl;
						// console.log(data);
						var tootlips=this.public_tooltip; 
						$.getJSON(mapUrl, function(geoJson) {
							echarts.registerMap('taizhou', geoJson);
							myChart.hideLoading(); 
							for(var i= 0;i<data.length;i++){ 
								data[i].name = data[i].areaName;
								data[i].value = data[i].jj0101;
								if(data[i].name=="姜堰区"){
									data[i].name = '姜堰市';
								}
							}
							var option = {
								backgroundColor: 'rgba(0,0,0,0)',
								title: {
									text: '',
									subtext: '',
									left: 20,
									bottom:130,
									textStyle: {
										color: '#fff',
										fontWeight: 700,
										fontSize: 18,
									},
								}, 
								
								tooltip:{
									alwaysShowContent: true,
									show: true,
									hoverAnimation: true,
									trigger: 'item', //触发类型 散点图
									enterable: true, //鼠标是否可进入提示框
									transitionDuration: 1, //提示框移动动画过渡时间
									triggerOn: 'click',
									borderWidth: '1px',
									borderRadius: '4',
									borderColor: '#f30',
									// backgroundColor: "rgba(0,0,0,.8)",   //提示框背景色
									textStyle: {
										// color: '#fff'					//提示框文字颜色
									}, 
									formatter:function(parms){
										if(! isNaN(parms.value)){
											return "<h4 class='oh'><span class='fl'>地区</span><span class='fr'>"+parms.name+"</span></h4><div class='oh'><span class='fl' style='margin-right:20px'>GDP（亿元）</span><span class='fr'>"+parms.value+"</span></div>";
										}else{
											return parms.name;
										}
									}, 
									confine: true, //提示框被遮挡  是否将 tooltip 框限制在图表的区域内 
									   position: function(point, params, dom, rect, size){ // point: 鼠标位置 
												if(point[0]>size.viewSize[0]){ // contentSize: 提示dom 窗口大小  // viewSize: echarts 容器大小
													     return point[0]-(size.viewSize[0]-point[0]);   //当提示框超出容器高度时用 提示框现有高度-容器高度
												} 
										}
								},
								geo: {
									map: 'taizhou',
									aspectScale:0.8,
									layoutCenter: ['50%', '50.5%'],
									layoutSize: '100%',
									silent: true,
									roam: false,
									z: 0,
									itemStyle: {
										normal: {
											areaColor: 'rgba(0,0,0,.5)',
											shadowColor: 'rgba(255,255,255, 1)',
											shadowBlur: 0,
											shadowOffsetX: 0,
											shadowOffsetY: 1,
											borderColor: 'rgba(255,255,255, 0.7)',
											borderWidth: 0.5,
										},
										emphasis: {
											areaColor: 'rgba(0,0,0,0)',
											borderWidth: 1,
											color: 'green',
											label: {
												show: true,
											},
										},
									},
								},
								series: [
									{
									type: 'map',
									zoom: 1.1,
									// roam: false,
									map: 'taizhou',
									roam: false,
									data:data,
									label: {
										normal: {
											show: true,
											textStyle: {
												color: '#fff',
											},
										},
										emphasis: {
											textStyle: {
												color: '#fff',
											},
										},
									},
									itemStyle: {
										normal: {
											borderColor: '#6185be',
											borderWidth: 1,
											// areaColor: {
											// 	image: mappng,
											// 	repeat: 'repeat',
											// },
											areaColor:"#1564cb",
											shadowColor: '#000',
											shadowBlur: 0,
											shadowOffsetX: 0,
											shadowOffsetY: 1,
										},
										emphasis: {
											// areaColor: {
											// 	image: '#f60',
											// 	repeat: 'repeat',
											// },
											areaColor:"#75cdfd",
											borderColor: '#',
											borderWidth: 1,
											shadowColor: '#75cdfd',
											shadowBlur: 10,
											shadowOffsetX: 2,
											shadowOffsetY: 1,
											label: {
												show: true,
											},
										},
									},
									
								}, 
								{
																			type:"effectScatter",       //带有涟漪特效动画的散点（气泡）图。
																			data:scdata,
																			coordinateSystem:'geo',     //'geo',使用地理坐标系/ 该系列使用的坐标系，'cartesian2d',使用二维的直角坐标系/'polar'使用极坐标系，
																			rippleEffect:{              //涟漪特效相关配置。
																							scale:8,        // 波纹的最大缩放比例
																							color:'#db7e43',        //涟漪颜色
																							period:3,       // 动画的周期，秒数
																							brushType:'fill'      // 波纹样式：'stroke'  ，'fill'
																			},
																			         symbol:'',						   //散点形状设置symbol: 'circle’, ‘rect’, ‘roundRect’, ‘triangle’, ‘diamond’, ‘pin’, 'arrow’
																			        itemStyle:{
																			            normal:{
																			                color:'#db7e43',		//圆点颜色
																			                shadowColor:'',   //圆点阴影
																			                // shadowBlur:3,
																			                // shadowOffsetX:1,
																			                // shadowOffsetY:2
																			            }
																			        },
															}
								],
							};
							myChart.setOption(option);
						});
						var hourIndex = 0;
						var fhourTime = null;
						fhourTime = setInterval(function() {
							myChart.dispatchAction({
								type: "downplay",
								seriesIndex: 0,
		
							});
							myChart.dispatchAction({
								type: "highlight",
								seriesIndex: 0,
								dataIndex: hourIndex
							});
							myChart.dispatchAction({
								type: "showTip",
								seriesIndex: 0,
								dataIndex: hourIndex
							});
							hourIndex++;
							if (hourIndex > data.length) {
								hourIndex = 0;
							}
						}, 3000);
						//鼠标移入停止轮播
						myChart.on("mousemove", function(e) {
							clearInterval(fhourTime)
							myChart.dispatchAction({
								type: "downplay",
								seriesIndex: 0,
							});
							myChart.dispatchAction({
								type: "highlight",
								seriesIndex: 0,
								dataIndex: e.dataIndex
							});
							myChart.dispatchAction({
								type: "showTip",
								seriesIndex: 0,
								dataIndex: e.dataIndex
							});
						})
						//鼠标移出恢复轮播
						myChart.on("mouseout", function() {
							fhourTime = setInterval(function() {
								myChart.dispatchAction({
									type: "downplay",
									seriesIndex: 0,
								});
								myChart.dispatchAction({
									type: "highlight",
									seriesIndex: 0,
									dataIndex: hourIndex
								});
								myChart.dispatchAction({
									type: "showTip",
									seriesIndex: 0,
									dataIndex: hourIndex
								});
								hourIndex++;
								if (hourIndex > data.length) {
									hourIndex = 0;
								}
							}, 3000);
						})
					},
		
		}
	}
</script>

<style> 
 @import url("../../css/dataswiper.css");
	

		
</style>
